import { all, fork } from 'redux-saga/effects';
import operationsSaga from '../usecases/operation/operationSaga';
import { adminSaga } from 'react-admin';
import authenticationSaga from '../usecases/authentication/authenticationSaga';
import mesurementSaga from '../usecases/measurement/mesurementSaga';
import billingSaga from '../usecases/billing/billingSaga';
import billingNewSaga from '../usecases/billing/billingNewSaga';
import participantSaga from '../usecases/participant/participantSaga';
import accountSaga from '../usecases/account/accountSaga';
import navigationSaga from '../usecases/navigation/navigationSaga';
import billCheckSaga from '../usecases/billCheck/billCheckSaga';
import communicationSaga from '../usecases/communication/communicationSaga';
import energyAllocationSaga from '../usecases/energyAllocation/energyAllocationSaga';
import paymentSagas from '../usecases/payment/paymentSaga';
import uploadSagas from '../usecases/upload/uploadSaga';
import notificationsSaga from '../usecases/notifications/notificationsSaga';

const sagas = [
    ...operationsSaga,
    ...authenticationSaga,
    ...mesurementSaga,
    ...accountSaga,
    ...billingSaga,
    ...billingNewSaga,
    ...participantSaga,
    ...navigationSaga,
    ...billCheckSaga,
    ...communicationSaga,
    ...energyAllocationSaga,
    ...paymentSagas,
    ...uploadSagas,
    ...notificationsSaga,
];

export default function rootSaga(dataProvider, authProvider) {
    return function* () {
        yield all(
            [
                //admin saga
                adminSaga(dataProvider, authProvider),
                ...sagas,
            ].map(fork)
        );
    };
}
